import {
  featuredProducts,
  titleTextColor,
} from '@/src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage-revamp/constant';
import {
  backgroundStyle,
  items,
  policy,
  primaryColor,
  tabColor,
  textColor,
  profileContentManagement,
  myAddress,
  subscriptionBuy,
  thirdPartyLogin,
  voucher,
} from '@/src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage-revamp/constant';
import { isEqual, get } from 'lodash';

const fields = [
  [featuredProducts, titleTextColor],
  [backgroundStyle, primaryColor],
  [backgroundStyle, tabColor],
  [backgroundStyle, textColor],
  [profileContentManagement, myAddress],
  [profileContentManagement, subscriptionBuy],
  [profileContentManagement, thirdPartyLogin],
  [profileContentManagement, voucher],
];
const policyName = [policy, items];

export default (
  changeFields: Array<any>,
  { pcForm, tabletForm, mobileForm },
) => {
  changeFields.map((field) => {
    const name = field?.name;
    const value = field?.value;

    if (fields.findIndex((v) => isEqual(name, v)) !== -1) {
      tabletForm.setFields([{ name, value }]);
      mobileForm.setFields([{ name, value }]);
    }
    const n0 = get(name, 0);
    const n1 = get(name, 1);
    if (n0 === policyName[0] && n1 === policyName[1]) {
      tabletForm.setFields([{ name, value }]);
      mobileForm.setFields([{ name, value }]);
    }
    //if(){}
  });
};
